import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getAuth, GoogleAuthProvider, OAuthProvider } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyC_an-3FsvmGr8m4pVUY7Oc2X9xUDIg1-I",
    authDomain: "exam-e7415.firebaseapp.com",
    projectId: "exam-e7415",
    storageBucket: "exam-e7415.firebasestorage.app",
    messagingSenderId: "110044532138",
    appId: "1:110044532138:web:c21674998cf72e7cdb6fd3",
    measurementId: "G-64PHPLZQTZ"
  };

const app = initializeApp(firebaseConfig);

// Initialize analytics only if supported (prevents IndexedDB warnings in tests)
let analytics = null;
isSupported().then(yes => yes ? analytics = getAnalytics(app) : null);

const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

const googleProvider = new GoogleAuthProvider();
const microsoftProvider = new OAuthProvider('microsoft.com');

export { auth, db, storage, analytics, googleProvider, microsoftProvider }; 
